import React from "react";

const routes = new Map();
let hoverTimer;

// Only JavaScript is preloaded. Protected components still mount exclusively
// through the existing authentication and permission gates.
export function lazyPage(loadModule, exportName = "default") {
  let pending;
  const load = () => {
    if (!pending) {
      pending = Promise.resolve().then(loadModule).catch(error => {
        pending = undefined; // A speculative network failure must be retryable.
        throw error;
      });
    }
    return pending;
  };
  const Page = React.lazy(() => load().then(module => ({ default: module[exportName] })));
  Page.preload = load;
  return Page;
}

export function registerPagePreloaders(pages) {
  Object.entries(pages).forEach(([path, page]) => routes.set(path, page.preload));
}

export function preloadPage(path, { speculative = false } = {}) {
  const connection = typeof navigator !== "undefined" ? navigator.connection : null;
  if (speculative && (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || ""))) {
    return Promise.resolve();
  }
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  const load = routes.get(pathname);
  // Never turn a failed hover-prefetch into an unhandled error or a navigation
  // failure. Normal navigation still invokes the loader again.
  return load ? load().catch(() => undefined) : Promise.resolve();
}

export function cancelPagePreload() {
  clearTimeout(hoverTimer);
}

export function schedulePagePreload(path) {
  cancelPagePreload();
  // Moving the mouse through the sidebar must not download every page passed.
  hoverTimer = setTimeout(() => preloadPage(path, { speculative: true }), 150);
}
